import { render, staticRenderFns } from "./TicketLogsModal.vue?vue&type=template&id=143ef9f4&scoped=true&"
import script from "./TicketLogsModal.vue?vue&type=script&lang=js&"
export * from "./TicketLogsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143ef9f4",
  null
  
)

export default component.exports